export default "__VITE_ASSET__BxDRoR3s__"